import { ChangeDetectionStrategy, Component, computed, inject, input, model, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';

import { ImageSelectorComponent } from '@connect-services/client/components/image-selector/image-selector.component';
import { SelfProfileFormType } from '@connect-services/client/components/profile-modal/profile-modal.component';
import { SecurityService } from '@connect-services/client/services/security.service';
import { TranslationLang } from '@connect-services/client/services/translate.service';
import { InputTextComponent } from '@connect-services/src/lib/components/input/text/input-text/input-text.component';
import { SelectComponent, SelectOption } from '@connect-services/src/lib/components/select/select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImageSelectorComponent, InputTextComponent, RessourcesModule, SelectComponent],
    selector: 'app-profile-edition',
    templateUrl: './profile-edition.component.html',
})
export class ProfileEditionComponent implements OnInit {
    public readonly defaultSelectValue = computed(() =>
        this.languageOptions.filter((languageOption) => languageOption.value === this.selectedLang()),
    );
    public languageOptions: SelectOption<TranslationLang>[] = [];
    public readonly profileForm = input.required<FormGroup<SelfProfileFormType>>();
    public readonly selectedLang = model<TranslationLang>(TranslationLang.FR);

    protected readonly securityService = inject(SecurityService);

    private readonly translocoService = inject(TranslocoService);

    public ngOnInit(): void {
        this.languageOptions = this.initLanguageOption();
    }

    public selectLang(lang: TranslationLang[]): void {
        this.selectedLang.set(lang[0]);
    }

    private initLanguageOption(): SelectOption<TranslationLang>[] {
        return Object.values(TranslationLang).map((translationLang): SelectOption<TranslationLang> => {
            return { label: this.translocoService.translate(translationLang), value: translationLang };
        });
    }
}
